module.exports = __webpack_public_path__ + "static/media/nHJFhX9M8e.20b744fa.jpg";